import request from '@/utils/request'

export function submitQuot(param) {
  let data = param
  return request({
    url: `/quotation/epms1040/submitQuot`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'multipart/form-data' },
    data
  })
}